import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
import { AuthService } from './../../../../../../shared/services/auth.service';
import { AnotacionesService } from './anotaciones.service';
import { AnotacionesEntry } from './../../../../../../shared/entrys/anotaciones.entry';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
	selector: 'app-anotaciones',
	templateUrl: './anotaciones.component.html',
	styleUrls: ['./anotaciones.component.scss']
})
export class AnotacionesComponent implements OnInit, OnDestroy {
	headers: string[] = [];
	formFiltroAnotaciones: FormGroup;
	modelFechaIniAnota;
	modelFechaFinAnota;
	anotaciones: Array<AnotacionesEntry>;
	dataTabla: DatoPaginadoModel;
	paginaActual: number;
	constructor(private formBuilder: FormBuilder, private anotacionesServices: AnotacionesService, private authService: AuthService) {
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.headers = ['# de Anotación', 'F. Registro', 'Establecimiento', 'T. Anotación', 'Estado del RNT', 'IP', 'Anotación'];
		this.formFiltroAnotaciones = this.formBuilder.group({
			tipoAnotacion: ['', Validators.required],
			ipHaceSolicitud: ['', Validators.required],
			fechaInicioAnota: ['', Validators.required],
			fechaFinAnota: ['', Validators.required]
		});
		this.anotacionesServices.get(this.formFiltroAnotaciones.value).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.anotaciones = this.dataTabla.items as Array<AnotacionesEntry>;
			}
		});
	}

	ngOnDestroy(): void {

	}

	onFiltrar() {
		this.paginaActual = 1;
		this.anotacionesServices.getFilter(this.formFiltroAnotaciones.value).subscribe(resultado => {
			if (resultado.result) {
				this.anotaciones = resultado.data.items as Array<AnotacionesEntry>;
			}
		});
	}


	onPaginado(page: number) {
		this.paginaActual = page;
		this.anotacionesServices.getPaginador(this.formFiltroAnotaciones.value, page).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.anotaciones = this.dataTabla.items as Array<AnotacionesEntry>;
			}
		});

	}



}
